import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Check, ShieldCheck, Mail } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section id="precio" className="py-24 bg-[#FFF7ED] relative overflow-hidden" data-id="element-60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-61">
        <div className="max-w-md mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-orange-100" data-id="element-62">
          {/* Header */}
          <div className="bg-[#064E3B] p-8 text-center text-white" data-id="element-63">
            <h2 className="text-2xl font-bold mb-2" data-id="element-64">
              Comienza Tu Metabo-Reset Hoy
            </h2>
            <p className="text-gray-300 text-sm" data-id="element-65">
              Únete al Protocolo Metabo-Reset 40+
            </p>
          </div>

          {/* Body */}
          <div className="p-8 md:p-10" data-id="element-66">
            {/* Price */}
            <div className="text-center mb-8" data-id="element-67">
              <p className="text-gray-400 line-through text-lg mb-1" data-id="element-68">
                Precio Regular: $97 USD
              </p>
              <div className="text-6xl font-extrabold text-[#0D6B4F] tracking-tight" data-id="element-69">
                $6,36
              </div>
            </div>

            {/* Countdown */}
            <div className="flex justify-center mb-8" data-id="element-70">
              <CountdownTimer data-id="element-71" />
            </div>

            {/* Benefits List */}
            <div className="space-y-4 mb-8" data-id="element-72">
              {['Protocolo completo de 3 fases (21 días)', 'Recetario Sabor Latino con +20 recetas', 'Protocolo Mínimo Efectivo de 12 min', 'Guía de Suplementación Inteligente'].map((item, index) => <div key={index} className="flex items-start" data-id="element-73">
                  <div className="bg-[#FFF7ED] p-1 rounded-full mr-3 mt-0.5" data-id="element-74">
                    <Check className="text-[#F97316]" size={14} strokeWidth={3} data-id="element-75" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-76">{item}</span>
                </div>)}

              {/* Delivery Info Item */}
              <div className="flex items-start bg-blue-50 p-3 rounded-lg border border-blue-100" data-id="element-77">
                <div className="bg-white p-1 rounded-full mr-3 mt-0.5 shadow-sm" data-id="element-78">
                  <Mail className="text-blue-500" size={14} strokeWidth={3} data-id="element-79" />
                </div>
                <span className="text-blue-800 font-medium text-sm" data-id="element-80">
                  Entrega inmediata a tu email (PDF)
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <Button size="lg" withArrow bounce href="https://ecoterr4.com/cart/44441705480271:1" trackCart className="w-full shadow-xl shadow-[#F97316]/20 mb-6" data-id="element-81">
              ¡SÍ, QUIERO EMPEZAR MI METABO-RESET HOY!
            </Button>

            {/* Security Badge */}
            <div className="flex items-center justify-center text-xs text-gray-500 bg-gray-50 py-2 rounded-lg border border-gray-100" data-id="element-82">
              <ShieldCheck size={14} className="mr-1.5 text-[#0D6B4F]" data-id="element-83" />
              <span data-id="element-84">Pago 100% Seguro y Encriptado</span>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-85">
          <p className="text-gray-400 text-xs max-w-2xl mx-auto" data-id="element-86">
            Descargo de responsabilidad: Los resultados pueden variar de una
            persona a otra. Este producto no sustituye el consejo médico
            profesional.
          </p>
        </div>
      </div>
    </section>;
}